import React from 'react';
import './charts.css';

const BLUE = '#0066CC';

/**
 * An ordered funnel: bars scaled to the FIRST stage, with the drop-off
 * between consecutive stages stated in words.
 *
 * Scaling to the first stage rather than to each bar's predecessor is the
 * whole point -- predecessor-scaling renders every funnel as a near-identical
 * staircase and hides exactly the collapse you are looking for.
 */
export default function FunnelBars({ stages = [] }) {
  const first = stages.length ? stages[0].count : 0;
  return (
    <div className="funnel">
      {stages.map((s, i) => {
        const pct = first > 0 ? (s.count / first) * 100 : 0;
        return (
          <div key={s.key} className="funnel__row">
            <div className="funnel__label">{s.label}</div>
            <div className="funnel__track">
              <div
                data-testid={`funnel-bar-${s.key}`}
                className="funnel__bar"
                style={{ width: `${pct}%`, background: BLUE, height: 24 }}
              />
            </div>
            <div className="funnel__value">{s.count}</div>
            {i > 0 && s.pctFromPrev != null && (
              <div className="funnel__drop" data-testid={`funnel-drop-${s.key}`}>
                {Math.round(s.pctFromPrev * 100)}% of previous
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
